import axiosinstance from "../../../api/axiosinstance";
import securedInstance from "../../../api/securedInstance";
import { toast } from "react-toastify";
import axios from "axios";

import {
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  FETCH_CHANNEL_PARTNERS_SUCCESS,
  FETCH_CHANNEL_PARTNERS_FAILURE,
  APPROVE_REQUEST_SUCCESS,
  APPROVE_REQUEST_FAILURE,
  REJECT_REQUEST_SUCCESS,
  REJECT_REQUEST_FAILURE,
  FETCH_PENDING_REQUESTS_SUCCESS,
  FETCH_PENDING_REQUESTS_FAILURE,
  ENROLL_SUCCESS, // Added Enrollment Success
  ENROLL_FAILURE, // Added Enrollment Failure
} from "./authTypes";

// ✅ Register user
export const register = (userData) => async (dispatch) => {
  try {
    const res = await axiosinstance.post("/api/auth/register", userData, {
      headers: { "Content-Type": "application/json" },
    });

    dispatch({
      type: REGISTER_SUCCESS,
      payload: res.data,
    });

    toast.success("You have Registered Successfully");
  } catch (error) {
    toast.error(error.response?.data?.error + " Please TRY again");
    dispatch({
      type: REGISTER_FAILURE,
      payload: error.response?.data?.error || "Registration failed",
    });
  }
};

// ✅ Enroll User (Simplified registration)
export const enrollUser = (enrollmentData) => async (dispatch) => {
  try {
    console.log("📤 Sending enrollment data to backend:", JSON.stringify(enrollmentData));

    const res = await axiosinstance.post("/api/auth/enroll", enrollmentData, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    console.log("✅ Enrollment Success:", res.data);

    dispatch({
      type: ENROLL_SUCCESS,
      payload: res.data,
    });

    toast.success("You have successfully enrolled!");
  } catch (error) {
    console.error("❌ Enrollment Error:", error.response?.data || error.message);

    dispatch({
      type: ENROLL_FAILURE,
      payload: error.response?.data?.error || "Enrollment failed",
    });

    toast.error(error.response?.data?.error || "Enrollment failed. Please try again.");
  }
};



// ✅ Login user
export const login = (credentials) => async (dispatch) => {
  try {
    const response = await axiosinstance.post('/api/auth/login', credentials); // Update URL as per your backend
    const userData = response.data;

    // Save user data to localStorage
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("token", userData.token); // Save token to localStorage

    // Dispatch login success
    dispatch({
      type: 'LOGIN_SUCCESS',
      payload: userData, // Includes email
    });
  } catch (error) {
    dispatch({
      type: 'LOGIN_FAILURE',
      payload: error.response?.data?.message || "Something went wrong",
    });
  }
};



// ✅ Logout user
export const logout = () => (dispatch) => {
  localStorage.removeItem("token");   // ✅ Remove token
  localStorage.removeItem("user");
  localStorage.removeItem("email")   // ✅ Remove email

  dispatch({ type: "LOGOUT" });

  toast.success("You have successfully Logged Out");
};

// ✅ Fetch Channel Partners
export const fetchChannelPartners = () => async (dispatch) => {
  try {
    const response = await fetch("http://localhost:8000/api/channelPartner");
    if (response.ok) {
      const data = await response.json();
      dispatch({
        type: FETCH_CHANNEL_PARTNERS_SUCCESS,
        payload: data,
      });
    } else {
      dispatch({
        type: FETCH_CHANNEL_PARTNERS_FAILURE,
        payload: "Error fetching Channel Partners",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_CHANNEL_PARTNERS_FAILURE,
      payload: "Error fetching Channel Partners",
    });
  }
};

// ✅ Approve Request
export const approveRequest = (cpId) => async (dispatch) => {
  try {
    const response = await fetch(`http://localhost:8000/api/CPauth/approveRequest/${cpId}`, {
      method: "PUT",
    });
    if (response.ok) {
      dispatch({
        type: APPROVE_REQUEST_SUCCESS,
        payload: "Request approved successfully.",
      });
    } else {
      const error = await response.json();
      dispatch({
        type: APPROVE_REQUEST_FAILURE,
        payload: error,
      });
    }
  } catch (error) {
    dispatch({
      type: APPROVE_REQUEST_FAILURE,
      payload: "An error occurred while approving the request.",
    });
  }
};

// ✅ Reject Request
export const rejectRequest = (cpId) => async (dispatch) => {
  try {
    const response = await fetch(`http://localhost:8000/api/CPauth/rejectRequest/${cpId}`, {
      method: "DELETE",
    });
    if (response.ok) {
      dispatch({
        type: REJECT_REQUEST_SUCCESS,
        payload: "Request rejected successfully.",
      });
    } else {
      const error = await response.json();
      dispatch({
        type: REJECT_REQUEST_FAILURE,
        payload: error,
      });
    }
  } catch (error) {
    dispatch({
      type: REJECT_REQUEST_FAILURE,
      payload: "An error occurred while rejecting the request.",
    });
  }
};

// ✅ Fetch Pending Requests
export const fetchPendingRequests = () => async (dispatch) => {
  try {
    const response = await fetch("http://localhost:8000/api/channelPartner");
    if (response.ok) {
      const data = await response.json();
      dispatch({
        type: FETCH_PENDING_REQUESTS_SUCCESS,
        payload: data.filter((request) => request.status === 0),
      });
    } else {
      dispatch({
        type: FETCH_PENDING_REQUESTS_FAILURE,
        payload: "Error fetching pending registration requests",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_PENDING_REQUESTS_FAILURE,
      payload: "Error fetching pending registration requests",
    });
  }
};
